var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications'),_c('router-view',{attrs:{"to":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }